const feLog = ({ src = "frontend", step, ...rest } = {}) => {
  try {
    const query = new URLSearchParams({
      src,
      step: String(step || ""),
    });

    Object.entries(rest).forEach(([key, value]) => {
      if (value == null) return;
      query.set(key, String(value).slice(0, 500));
    });

    const url = `/__fe-log?${query.toString()}`;

    if (typeof navigator !== "undefined" && typeof navigator.sendBeacon === "function") {
      navigator.sendBeacon(url);
      return;
    }

    fetch(url, { keepalive: true }).catch(() => {});
  } catch (_) {
    // El log no debe romper la app.
  }
};

export default feLog;
